export default [
	{
		settings: true,
		text: "ID",
		value: "id",
		func: true,
		valueFilter: "filter_id",
		model: { value: 'list' },
		sortable: true,
		footer: "unique"
	},
	{
		settings: true,
		text: "Date",
		value: "date_create",
		valueFilter: 'filter_date',
		model: { value: 'date' },
		func: true,
		sortable: true,
		dense: true,
		nowrap: true
	},

	{
		settings: true,
		text: "Amount",
		value: "amount",
		func: true,
		valueFilter: 'filter_amount',
		model: { value: 'number' },
		sortable: true,
		toLeft: true,
		modValue: 'isDeCode',
		dollar: true,
		fullTotal: true
	},

	{
		settings: true,
		text: "Status",
		value: "status",
		func: false,
		valueFilter: 'filter_status',
		model: { value: 'list' },
		sortable: false,
		toLeft: true,
		modValue: 'paidComplete'
	},

	// {
	// 	settings: true,
	// 	text: "Type",
	// 	value: "type_number",
	// 	func: true,
	// 	valueFilter: 'filter_type',
	// 	model: { value: 'list' },
	// 	sortable: true,
	// },

	{
		settings: true,
		text: "Name",
		value: "name",
		func: true,
		valueFilter: 'filter_name',
		model: { value: 'list' },
		sortable: true,
	},

	{
		settings: true,
		text: "Description",
		value: "original_description",
		func: true,
		valueFilter: 'filter_original_description',
		model: { value: 'note' },
		sortable: true,
	},

	// {
	// 	settings: true,
	// 	buttons: [
	// 		{
	// 			perm: { or: [ 10, 9 ] },
	// 			value: 'edit',
	// 			text: 'Edit driver',
	// 			icon: { value: 'edit', w: 18, h: 18 },
	// 		},
	// 		{
	// 			perm: {
	// 				or: [ 11 ]
	// 			},
	// 			value: 'delete',
	// 			text: 'Delete driver',
	// 			icon: { value: 'deleteItem', w: 18, h: 18 },
	// 		}
	// 	]
	// },
];
